import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/control-bibliografico")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/control-bibliografico", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia/control-bibliografico", replace: true });
  },
});
